import React from 'react';
import { useLocation } from 'react-router-dom';
import { Helmet } from 'react-helmet-async';

const DEFAULT_TITLE = 'The Wiry | Digital Marketing Agency – SEO, Social Media & Branding in NYC';
const DEFAULT_DESC = 'The Wiry is a New York digital marketing agency. SEO, social media marketing, Google Ads, content creation, and branding. Get a free quote today.';
const SITE_NAME = 'The Wiry';
const BASE_URL = 'https://www.thewiry.com';

export const routeSEO = {
  '/': {
    title: 'The Wiry | Digital Marketing Agency – SEO, Social Media & Branding in NYC',
    description: 'The Wiry is a New York digital marketing agency. We offer SEO, social media marketing, Google Ads, content creation, and branding to grow your business. Get a free quote today.',
    keywords: 'digital marketing agency NYC, SEO services New York, social media marketing, Google SEO, content marketing, brand strategy, New York marketing agency',
  },
  '/getquote': {
    title: 'Get a Quote | The Wiry – SEO, Social Media & Digital Marketing',
    description: 'Get a free quote for SEO, social media marketing, Google Ads, content creation, and branding. The Wiry – digital marketing agency in New York.',
    keywords: 'SEO quote, social media marketing quote, digital marketing quote NYC, free marketing consultation',
  },
  '/contactus': {
    title: 'Contact Us | The Wiry – Digital Marketing Agency NYC',
    description: 'Contact The Wiry for SEO, social media, and digital marketing. New York-based agency. Get in touch today.',
    keywords: 'contact digital marketing agency NYC, The Wiry contact, marketing consultancy New York',
  },
  '/service/seo': {
    title: 'SEO Services NYC | Search Engine Optimization – The Wiry',
    description: 'Professional SEO services in New York: keyword research, on-page optimization, link building, content strategy. Rank higher on Google with The Wiry.',
    keywords: 'SEO services New York, search engine optimization NYC, Google ranking, keyword research, link building, SEO audit, local SEO, organic search',
  },
  '/service/social-media': {
    title: 'Social Media Marketing NYC | Instagram, TikTok – The Wiry',
    description: 'Social media marketing agency in New York. Strategy, content creation, Instagram, TikTok, and paid social. Grow your brand with The Wiry.',
    keywords: 'social media marketing NYC, Instagram marketing, TikTok marketing, social media strategy, content creation, brand awareness, engagement',
  },
  '/service/digital': {
    title: 'Digital Solutions | Virtual Tours, Paid Ads & Branding – The Wiry',
    description: 'Full digital solutions: virtual tours, Google Ads, paid advertising, and branding. New York digital agency – The Wiry.',
    keywords: 'digital marketing solutions, virtual tours, Google Ads, PPC, paid advertising, branding agency NYC',
  },
  '/meet-the-team': {
    title: 'Meet the Team | Digital Marketing Experts – The Wiry',
    description: 'Meet the digital marketing and social media experts behind The Wiry. NYC-based team dedicated to your growth.',
    keywords: 'The Wiry team, digital marketing experts, SEO expert, social media expert NYC',
  },
  '/how-it-works': {
    title: 'How It Works | The Wiry – Digital Marketing Process',
    description: 'How The Wiry helps businesses grow: strategy, SEO, social media, content, and ongoing support. Learn our process.',
    keywords: 'digital marketing process, how SEO works, marketing strategy, business growth',
  },
  '/testimonials': {
    title: 'Testimonials & Reviews | The Wiry – Digital Marketing Agency',
    description: 'What clients say about The Wiry. Reviews and testimonials from businesses we helped with SEO and social media.',
    keywords: 'The Wiry reviews, digital marketing testimonials, client success stories',
  },
  '/careers': {
    title: 'Careers | Join The Wiry – Digital Marketing Agency NYC',
    description: 'Join The Wiry. Careers in digital marketing, SEO, and social media. New York-based agency hiring.',
    keywords: 'digital marketing jobs NYC, SEO jobs, social media jobs, careers The Wiry',
  },
  '/investors': {
    title: 'Investors | The Wiry – Digital Marketing & Growth Platform',
    description: 'The Wiry is building a digital marketing and growth platform. Information for investors.',
    keywords: 'The Wiry investors, digital marketing company, growth platform',
  },
  '/heli': {
    title: 'Social Media Expert | The Wiry',
    description: 'Meet our social media expert at The Wiry. Strategy, content, and brand growth.',
    keywords: 'social media expert, The Wiry team',
  },
};

export default function SEOHead() {
  const { pathname } = useLocation();
  const config = routeSEO[pathname] || { title: DEFAULT_TITLE, description: DEFAULT_DESC, keywords: '' };
  const title = config.title || DEFAULT_TITLE;
  const description = config.description || DEFAULT_DESC;
  const keywords = config.keywords || '';
  const canonical = pathname === '/' ? BASE_URL : `${BASE_URL}${pathname.replace(/\/$/, '')}`;

  return (
    <Helmet>
      <title>{title}</title>
      <meta name="description" content={description} />
      {keywords && <meta name="keywords" content={keywords} />}
      <link rel="canonical" href={canonical} />
      <meta property="og:title" content={title} />
      <meta property="og:description" content={description} />
      <meta property="og:url" content={canonical} />
      <meta property="og:site_name" content={SITE_NAME} />
      <meta name="twitter:title" content={title} />
      <meta name="twitter:description" content={description} />
    </Helmet>
  );
}
